import React from 'react';
import PropTypes from "prop-types";

import {FormattedMessage, FormattedNumber} from 'react-intl';
import {orderSummaryTotalsMessages} from '../../orderSummary/orderSummaryMessages';

const DiscountAmount = ({discountAmount}) => (
    <div className="line-item-discount">
        <FormattedMessage {...orderSummaryTotalsMessages.discounts} />
        :
        &nbsp;
        <span className="line-item-discount-amount">
            <FormattedNumber value={-discountAmount} format="currency" />
        </span>
    </div>
);

DiscountAmount.propTypes = {
    discountAmount: PropTypes.number.isRequired
};

export default DiscountAmount
